import { DatePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ILevelEmailAlerts } from '@create/Store/models/ILevelEmailAlerts';
import { TranslatePipe } from '@ngx-translate/core';
import { TriggerTypes } from '@shared/constants/TriggerTypes';
import { Preview } from '@shared/details/email-preview/Preview';

@Component({
  selector: 'app-email-preview',
  templateUrl: './email-preview.component.html',
  styleUrls: ['./email-preview.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DatePipe, TranslatePipe],
})
export class EmailPreviewComponent {
  @Input() preview: Preview;
  @Input() flags: ILevelEmailAlerts;
  @Input() triggerType: TriggerTypes;

  triggerTypes = TriggerTypes;
}
